// Raporty Rozhana — which row the user opened last.
//
// Clicking a پسولە number in the daily report leaves the report entirely: the
// sale goes to /rent (where it is then opened for editing through openSale),
// the others to /take-money, /back-koga, /Paradan, /Mandub. Coming back, the
// report is a wall of near-identical rows and nothing said which one had just
// been worked on. So the row is marked, and the marked row is highlighted and
// scrolled back into view.
//
// A row is identified by جوولە + پسولە number, never by its index in the list:
// the same number exists under more than one movement type (a فرۆشتن #5 and a
// پارەدان #5 are different invoices), and the list is refetched whenever the
// date range or the movement filter changes, which shifts every index.

export function rozhanaRowKey(code, jwlla) {
  return `${jwlla || ""}|${code}`;
}

// Centre a marked row inside its own scroll box (.JM / .tableFixHead are fixed
// height with their own scrollbar, and remount at the top). Deliberately not
// scrollIntoView, which would drag the whole page along with it.
export function centerRowInScroller(node, wrapSelector) {
  const wrap = node && node.closest(wrapSelector);
  if (!wrap) return;
  const wrapBox = wrap.getBoundingClientRect();
  const rowBox = node.getBoundingClientRect();
  // Already fully in view — the usual case when the row was just clicked.
  // Centring it there would yank the table out from under the click.
  if (rowBox.top >= wrapBox.top && rowBox.bottom <= wrapBox.bottom) return;
  wrap.scrollTop +=
    rowBox.top - wrapBox.top - (wrap.clientHeight - rowBox.height) / 2;
}
